/*
 *
 * UploadMedia constants
 *
 */

export const FLUSH_STATE = 'app/containers/UploadMedia/FLUSH_STATE';

export const CHANGE_DATA = 'app/containers/UploadMedia/CHANGE_DATA';

export const UPLOAD_MEDIA_FILE = 'app/containers/UploadMedia/UPLOAD_MEDIA_FILE';
export const UPLOAD_MEDIA_FILE_SUCCESS =
  'app/containers/UploadMedia/UPLOAD_MEDIA_FILE_SUCCESS';
export const UPLOAD_MEDIA_FILE_ERROR =
  'app/containers/UploadMedia/UPLOAD_MEDIA_FILE_ERROR';
